import { render, staticRenderFns } from "./VolunteerCardStandard.vue?vue&type=template&id=6daa8200"
import script from "./VolunteerCardStandard.vue?vue&type=script&lang=ts"
export * from "./VolunteerCardStandard.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerCardStandard.vue?vue&type=style&index=0&id=6daa8200&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports